const getIframePositionForElement = (liveElement) =>
  liveElement.ownerDocument.defaultView.frameElement.getBoundingClientRect();

export default getIframePositionForElement;
